import React from "react";
import Header from "../../components/Navbar";
import CardList from "../../components/card";

export default function Home() {
  return (
    <>
      {/* <Header /> */}
      <CardList />
    </>
  );
}
